import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './PromocodeDetail.css'
import { PromocodeConfig } from '../../../configs/stream-entities'
import Calendar from 'react-calendar'
import { PacmanLoader } from 'react-spinners'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/slide.css'
import Alert from 'react-s-alert'
import * as CopyToClipboard from 'react-copy-to-clipboard'
import * as config from '../../../configs/appConfig'

class PromocodeDetailProps {
    public promocodeId: string
}

class PromocodeDetailState extends PromocodeConfig {
    public forceReset: boolean = false
    public showLoader: boolean = false
}

class PromocodeDetail extends React.Component<PromocodeDetailProps, PromocodeDetailState> {

    private formRef: React.RefObject<HTMLFormElement>
    private branch = require('branch-sdk')

    constructor(props: PromocodeDetailProps) {
        super(props)
        if (window.location.hostname.indexOf('local') > -1 || window.location.hostname.indexOf("dev") > -1) {
            this.branch.init(config.branchAPIKeyDev)
        } else {
            this.branch.init(config.branchAPIKeyLive)
        }
        const newState = new PromocodeDetailState()
        newState.id = props.promocodeId
        newState.expirationDate = new Date()
        this.state = newState
        this.formRef = React.createRef<HTMLFormElement>()
        this.onCalendarChange = this.onCalendarChange.bind(this)
        this.onCodeChange = this.onCodeChange.bind(this)
        this.onDomainChange = this.onDomainChange.bind(this)
        this.onB2bFlagChanged = this.onB2bFlagChanged.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.resetForm = this.resetForm.bind(this)
        this.displayCopyAlert = this.displayCopyAlert.bind(this)
        this.onSubscriptionChanged = this.onSubscriptionChanged.bind(this)
    }

    public componentWillUpdate(nextProps: PromocodeDetailProps, nextState: PromocodeDetailState) {
        if (this.props.promocodeId !== nextProps.promocodeId) {
            firebase.firestore().collection('promocodes').doc(nextProps.promocodeId).get().then(snapshot => {
                Object.assign(nextState, snapshot.data())
                if (snapshot.data()!.link === undefined) {
                    nextState.link = ''
                }
                if (snapshot.data()!.domain === undefined) {
                    nextState.domain = ''
                }
                if (snapshot.data()!.isB2b === undefined) {
                    nextState.isB2b = false
                }
                if (snapshot.data()!.subscriptionId === undefined) {
                    nextState.subscriptionId = ''
                }
                nextState.expirationDate = snapshot.data()!.expirationDate.toDate()
                nextState.id = snapshot.id
                nextState.forceReset = false
                this.setState(nextState)
            })
        }
    }

    public render() {
        return (<div className="PromocodeDetail">
            <button onClick={this.resetForm}>New</button>
            {(this.state.link.length > 0) &&
                <div className="linkContainer">
                    <input type="text" name="link" value={this.state.link} disabled={true} />
                    <CopyToClipboard text={this.state.link} onCopy={this.displayCopyAlert}>
                        <button>Copy Link</button>
                    </CopyToClipboard>
                </div>
            }
            <form ref={this.formRef} onSubmit={this.onSubmit}>
                <label htmlFor="promoCode">Promocode:</label><br />
                <input type="text" name="promoCode" onChange={this.onCodeChange} required={true} value={this.state.code} placeholder="e.g.: Sony07" />
                <label htmlFor="emailDomain">Email Domain:<span className="alertRed">⚠️NO @ SIGN⚠️</span></label><br />
                <input type="text" name="emailDomain" onChange={this.onDomainChange} value={this.state.domain} placeholder="e.g.: journeymeditation.com" />
                <label htmlFor="isB2b" className="inlineLabel">Is for B2B?:
                    <input type="checkbox" id="isB2b" checked={this.state.isB2b} onChange={this.onB2bFlagChanged} />
                </label><br />
                <label>Pick up an expiration date:</label><br />
                <Calendar value={this.state.expirationDate} onChange={this.onCalendarChange} /><br />
                <label htmlFor="subscriptionId">Associated subscription (expiration date will be ignored):</label><br />
                <input type="text" name="subscriptionId" onChange={this.onSubscriptionChanged} value={this.state.subscriptionId} />
                {!this.state.showLoader ? <input type="submit" /> :
                    <div className='popup'>
                        <PacmanLoader css={'display: inline-block;'} loading={true} />
                    </div>}
            </form>
            <Alert stack={true} />
        </div>)
    }

    private onSubscriptionChanged(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ subscriptionId: event.currentTarget.value })
    }

    private onB2bFlagChanged(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ isB2b: event.currentTarget.checked })
    }

    private onCalendarChange(date: Date) {
        this.setState({ expirationDate: date })
    }

    private onCodeChange(event: React.ChangeEvent<HTMLInputElement>) {
        const newCode = event.currentTarget.value
        this.setState({ code: newCode.toLowerCase() })
    }

    private onDomainChange(event: React.ChangeEvent<HTMLInputElement>) {
        const newDomain = event.currentTarget.value
        if (newDomain.match(/^((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null) {
            event.target.setCustomValidity('')
        } else {
            event.target.setCustomValidity('Invalid Domain')
        }
        this.setState({ domain: newDomain.toLowerCase() })
    }

    private resetForm(_: any) {
        const newState = new PromocodeDetailState()
        newState.forceReset = true
        this.setState(newState)
    }

    private onSubmit(event: React.FormEvent) {
        event.preventDefault()
        if (this.formRef.current!.checkValidity()) {
            const generateLink = new Promise((resolve, reject) => {
                this.branch.link({
                    campaign: this.state.code,
                    channel: this.state.isB2b ? "B2B" : "Promo",
                    data: { code: this.state.code },
                    tags: [`${this.state.expirationDate.getFullYear()}-${this.state.expirationDate.getMonth()}-${this.state.expirationDate.getDate()}`]
                }, (err: Error, newLink: any) => {
                    if (err !== null) {
                        reject(err)
                    }
                    resolve(newLink)
                })
            })
            generateLink.then((link: string) => {
                const promocodeCollectionRef = firebase.firestore().collection('promocodes')
                let promoCodeRequest: Promise<any>
                let promoCodeId = ''
                const request = new PromocodeConfig()
                request.expirationDate = this.state.expirationDate
                request.code = this.state.code
                request.domain = this.state.domain
                request.link = link
                request.isB2b = this.state.isB2b
                request.subscriptionId = this.state.subscriptionId
                if (this.state.id.length < 1) {
                    promoCodeRequest = promocodeCollectionRef.add(Object.assign({}, request)).then(ref => {
                        promoCodeId = ref.id;
                        return ref.update({id: ref.id});
                    })
                } else {
                    request.id = this.state.id
                    promoCodeId = this.state.id
                    promoCodeRequest = promocodeCollectionRef.doc(request.id).update(Object.assign({}, request))
                }
                this.setState({ showLoader: true, 'link': link, id: promoCodeId })
                return promoCodeRequest
            }).then(result => {
                Alert.success(`Promocode ${this.state.code} added!`, {
                    effect: 'slide',
                    position: 'top',
                    timeout: 5000
                })
                this.setState({ showLoader: false })
            }).catch(err => {
                Alert.error(err.message, {
                    effect: 'slide',
                    position: 'top',
                    timeout: 5000
                })
                this.setState({ showLoader: false })
            })
        }
    }

    private displayCopyAlert() {
        Alert.success('Link copied!', {
            effect: 'slide',
            position: 'top',
            timeout: 5000
        })
    }
}

export default PromocodeDetail


// WEBPACK FOOTER //
// ./src/components/promocode/promocode-detail/PromocodeDetail.tsx